"use strict";

exports.__esModule = true;
exports.default = clone;
var _isObject = _interopRequireDefault(require("./isObject.js"));
var _isArray = _interopRequireDefault(require("./isArray.js"));
var _extend = _interopRequireDefault(require("./extend.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// Create a (shallow-cloned) duplicate of an object.
function clone(obj) {
  if (!(0, _isObject.default)(obj)) return obj;
  return (0, _isArray.default)(obj) ? obj.slice() : (0, _extend.default)({}, obj);
}